import { createInstance } from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en";
import { es } from "./locales/es";
import { fr } from "./locales/fr";
export const i18next = createInstance();
void i18next.use(initReactI18next).init({
    fallbackLng: "en",
    interpolation: {
        escapeValue: false
    },
    lng: "en",
    resources: {
        en: {
            translation: en
        },
        es: {
            translation: es
        },
        fr: {
            translation: fr
        }
    }
});
